import { useEffect, useCallback, useMemo, FC } from 'react';
import intl from 'react-intl-universal';
import { Dropdown, FormItem } from '@getsynapse/design-system';
import { Option } from 'utils/customTypes';
import { useProjectBusinessUnits } from 'Pages/ProjectsListPage/hooks/useProjectBusinessUnits/useProjectBusinessUnits';

interface ProjectBusinessUnitFilterProps {
  onSelect: (selected: string[]) => void;
  selected?: string[];
}

const ProjectBusinessUnitFilter: FC<ProjectBusinessUnitFilterProps> = ({
  onSelect,
  selected,
}) => {
  const { fetchBusinessTeams, businessTeams, canFetchMoreBusinessTeams } =
    useProjectBusinessUnits({});

  useEffect(() => {
    fetchBusinessTeams();
  }, [fetchBusinessTeams]);

  const options = useMemo(() => {
    return businessTeams.map((businessTeam) => ({
      label: businessTeam.name,
      value: businessTeam.id,
    }));
  }, [businessTeams]);

  const selectedBusinessUnits = useMemo(() => {
    return businessTeams
      .filter((businessUnit) => selected?.includes(businessUnit.id))
      .map((businessUnit) => ({
        label: businessUnit.name,
        value: businessUnit.id,
      }));
  }, [selected, businessTeams]);

  const handleChange = useCallback(
    (options: Option[]) => {
      const selectedIds = options.map((option) => option.value);
      onSelect(selectedIds);
    },
    [onSelect]
  );

  return (
    <FormItem label={intl.get('PROJECT_DETAIL.BUSINESS_UNIT')}>
      <Dropdown
        options={options}
        values={selectedBusinessUnits}
        onChange={handleChange}
        enableLazyLoading={canFetchMoreBusinessTeams}
        loadMoreOptions={fetchBusinessTeams}
        multiple
        placeholder={intl.get('FILTER_GENERAL.PLACEHOLDER')}
        triggerProps={{
          'aria-label': 'project-business-unit-filter',
        }}
      />
    </FormItem>
  );
};

export default ProjectBusinessUnitFilter;
